import { render, staticRenderFns } from "./news-modal.vue?vue&type=template&id=87108902"
import script from "./news-modal.vue?vue&type=script&lang=js"
export * from "./news-modal.vue?vue&type=script&lang=js"
import style0 from "./news-modal.vue?vue&type=style&index=0&id=87108902&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports